var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tr",
    { key: _vm.logId, attrs: { props: _vm.props } },
    [
      _c(
        "q-td",
        { key: "name", attrs: { props: _vm.props } },
        [
          !_vm.emitLog
            ? _c("router-link", { attrs: { to: _vm.detailLink } }, [
                _vm._v(_vm._s(_vm.logNo))
              ])
            : _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("click", _vm.log)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.logNo))]
              )
        ],
        1
      ),
      _vm._v(" "),
      _c("q-td", { key: "species", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.speciesName))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "logArea", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm._f("number")(_vm.logArea, _vm.userLocale)))
      ]),
      _vm._v(" "),
      _c(
        "q-td",
        { key: "resultAreaNotRemeasured", attrs: { props: _vm.props } },
        [
          _vm._v(
            _vm._s(
              _vm._f("number")(_vm.resultAreaNotRemeasured, _vm.userLocale)
            )
          )
        ]
      ),
      _vm._v(" "),
      _c("q-td", { key: "inLogPercentage", attrs: { props: _vm.props } }, [
        _vm._v(
          _vm._s(
            _vm._f("number")(
              (_vm.resultAreaNotRemeasured / _vm.logArea) * 100,
              _vm.userLocale,
              0,
              0
            )
          ) + "%"
        )
      ]),
      _vm._v(" "),
      _c("q-td", { key: "measuredArea", attrs: { props: _vm.props } }, [
        _vm._v(
          _vm._s(_vm._f("number")(_vm.resultAreaMeasuredBack, _vm.userLocale))
        )
      ]),
      _vm._v(" "),
      _c(
        "q-td",
        { key: "measuredAreaPercentage", attrs: { props: _vm.props } },
        [
          _vm._v(
            _vm._s(
              _vm._f("number")(
                (_vm.resultAreaMeasuredBack / _vm.resultAreaNotRemeasured) *
                  100,
                _vm.userLocale,
                0,
                0
              )
            ) + "%"
          )
        ]
      ),
      _vm._v(" "),
      _c("q-td", { key: "maxLength", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm._f("number")(_vm.maxLength, _vm.userLocale)))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "quality", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.customerQualityName))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "structure", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.structure))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "grade", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm._f("encodeGrade")(_vm.grade)))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "palletNo", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.palletNo))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "place", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.place))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "characteristic", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.characteristic))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "thickness", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm._f("number")(_vm.thicknessMm, _vm.userLocale)))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "internalQualityName", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.internalQualityName))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "logInfo", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.logInfo))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "palletInfo", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.palletInfo))
      ]),
      _vm._v(" "),
      _c(
        "q-td",
        { key: "actions", attrs: { props: _vm.props } },
        [
          _c("q-btn", {
            attrs: {
              icon:
                "img:\\typo3conf\\ext\\ig_warehouse\\Resources\\Public\\Icons\\tally-sheet.png",
              dense: ""
            },
            on: {
              click: function($event) {
                return _vm.showMeasurementListDialog(_vm.log)
              }
            }
          }),
          _vm._v(" "),
          _vm.user
            ? _c("q-btn", {
                attrs: {
                  "text-color": "primary",
                  icon: _vm.watchIcon,
                  dense: ""
                },
                on: {
                  click: function($event) {
                    return _vm.showWatchlistDialog(_vm.log)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }